import React, { useState } from "react";
import "./Event.css";

// dummy images (replace with your real images)
import img1 from "./images/AGM1.jpg";
import img2 from "./images/AGM2.jpg";
import img3 from "./images/AGM3.jpg";
import img4 from "./images/AGM4.jpg";
import img5 from "./images/AGM5.jpg";
import img6 from "./images/AGM6.jpg";
import img7 from "./images/AGM7.jpg";
import img8 from "./images/AGM9.jpg";
import img10 from "./images/AGM10.jpeg";
import img11 from "./images/AGM11.jpeg";
import img12 from "./images/AGM12.jpeg";
import img13 from "./images/AGM13.jpeg";
import img14 from "./images/AGM14.jpg";
import img15 from "./images/AGM15.jpg";
import img16 from "./images/AGM16.jpg";
import img17 from "./images/AGM17.jpg";
import img18 from "./images/AGM18.jpg";
import img19 from "./images/AGM19.jpg";








import img20 from "./images/AGM2528.jpeg";
import img21 from "./images/AGM2511.jpg";
import img22 from "./images/AGM2512.jpg";
import img23 from "./images/AGM2513.jpg";
import img24 from "./images/AGM2514.jpg";
import img25 from "./images/AGM2510.jpg";
import img26 from "./images/AGM2515.jpg";
import img27 from "./images/AGM2516.jpg";
import img28 from "./images/AGM2517.jpg";
import img29 from "./images/AGM2518.jpg";
import img30 from "./images/AGM2519.jpg";
import img31 from "./images/AGM2521.jpg";
import img32 from "./images/AGM2522.jpeg";
import img33 from "./images/AGM2523.jpeg";
import img34 from "./images/AGM2524.jpeg";
import img35 from "./images/AGM2525.jpeg";
import img36 from "./images/AGM2526.jpeg";
import img37 from "./images/AGM2527.jpeg";




import img39 from "./images/AGM253.jpg";
import img40 from "./images/AGM251.jpg";
import img41 from "./images/AGM252.jpg";
import img42 from "./images/AGM259.jpg";
import img43 from "./images/AGM254.jpg";
import img44 from "./images/AGM255.jpg";
import img45 from "./images/AGM256.jpg";
import img46 from "./images/AGM257.jpg";
import img47 from "./images/AGM258.jpg";





import img48 from "./images/EV1.jpg";
import img49 from "./images/EV2.jpg";
import img50 from "./images/EV3.jpg";
import img51 from "./images/EV4.jpg";
import img52 from "./images/EV5.jpg";
import img53 from "./images/EV6.jpg";
import img54 from "./images/EV7.jpg";
import img55 from "./images/EV8.jpg";
import img56 from "./images/EV9.jpg";
import img57 from "./images/EV10.jpg";
import img58 from "./images/EV11.jpg";
import img59 from "./images/EV12.jpg";
import img60 from "./images/EV13.jpg";
import img61 from "./images/EV14.jpg";
import img62 from "./images/EV15.jpg";
import img63 from "./images/EV16.jpg";
import img64 from "./images/EV17.jpg";



import img65 from "./images/RR1.jpg";
import img66 from "./images/RR2.jpg";
import img67 from "./images/RR3.jpg";
import img68 from "./images/RR4.jpg";
import img69 from "./images/RR5.jpg";
import img70 from "./images/RR6.jpg";
import img71 from "./images/RR7.jpg";
import img72 from "./images/RR8.jpg";
import img73 from "./images/RR9.jpg";
import img74 from "./images/RR10.jpg";
import img75 from "./images/RR11.jpg";
import img76 from "./images/RR12.jpg";
import img77 from "./images/RR13.jpg";
import img78 from "./images/RR14.jpg";
import img79 from "./images/RR15.jpg";
import img80 from "./images/RR16.jpg";
import img81 from "./images/RR17.jpg";
import img82 from "./images/RR18.jpg";
import img83 from "./images/RR19.jpg";
import img84 from "./images/RR25.jpeg";
import img85 from "./images/RR21.jpg";
import img86 from "./images/RR22.jpg";
import img87 from "./images/RR23.jpg";
import img88 from "./images/RR24.jpeg";






// import img89 from "./images/GM1.jpg";
// import img90 from "./images/GM2.jpg";
// import img91 from "./images/GM3.jpg";
// import img92 from "./images/GM4.jpg";
// import img93 from "./images/GM5.jpg";
// import img94 from "./images/GM6.jpg";
// import img95 from "./images/GM7.jpg";
// import img96 from "./images/GM8.jpg";
// import img97 from "./images/GM9.jpg";
// import img98 from "./images/GM10.jpg";
// import img99 from "./images/GM11.jpg";
// import img100 from "./images/GM12.jpg";
// import img101 from "./images/GM13.jpg";
// import img102 from "./images/GM14.jpg";
// import img103 from "./images/GM15.jpg";
// import img104 from "./images/GM16.jpg";
// import img105 from "./images/GM17.jpg";
// import img106 from "./images/GM18.jpg";
// import img107 from "./images/GM19.jpg";
// import img108 from "./images/GM20.jpg";
// import img109 from "./images/GM21.jpg";
// import img110 from "./images/GM22.jpg";









// const eventsData = [
//   {
//     id: 1,
//     title: "Annual General Meeting",
//     images: [img1, img2, img3, img4, img5, img6, img7, img8],
//   },
//   {
//     id: 2,
//     title: "Product Launch Event",
//     images: [img1, img2, img3, img4, img5, img6, img7, img8],
//   },
//   {
//     id: 3,
//     title: "Dealer & Partner Meet",
//     images: [img1, img2, img3, img4, img5, img6, img7, img8],
//   },
//   {
//     id: 4,
//     title: "Exhibition & Expo",
//     images: [img1, img2, img3, img4, img5, img6, img7, img8],
//   },
// ];


const eventsData = [
  {
    id: 1,
    title: "Annual General Meeting",
    images: [
      img1, img2, img3, img4, img5, img6, img7, img8, 
      img10, img11, img12, img13, img14, img15, img16, img17, img18, img19
    ],
  },
  {
    id: 2,
    title: "Product Launch Event",
    images: [
      img19, img20, img21, img22, img23, img24, img25, img26, img27,
      img28, img29, img30, img31, img32, img33, img34, img35, img36,
      img37, img39, img40, img41, img42, img43, img44, img45,
      img46, img47
    ],
  },
  {
    id: 3,
    title: "Dealer & Partner Meet",
    images: [
      img48, img49, img50, img51, img52, img53, img54, img55, img56,
      img57, img58, img59, img60, img61, img62, img63, img64
    ],
  },
  {
    id: 4,
    title: "Exhibition & Expo",
    images: [
      img65, img66, img67, img68, img69, img70, img71, img72, img73,
      img74, img75, img76, img77, img78, img79, img80, img81, img82,
      img83, img84, img85, img86, img87, img88
    ],
  },
];


const Events = () => {
  const [activeEvent, setActiveEvent] = useState(null);
  const [activeImage, setActiveImage] = useState(null);

  return (
    <section className="events-section">
      <h2 className="events-title">Our Events & Highlights</h2>

      <div className="events-grid">
        {eventsData.map((event) => (
          <div
            key={event.id}
            className="event-card"
            onClick={() => setActiveEvent(event)}
          >
            <img src={event.images[0]} alt={event.title} />
            <div className="event-overlay">
              <h3>{event.title}</h3>
              <span>View Gallery</span>
            </div>
          </div>
        ))}
      </div>

      {/* Event Modal */}
      {activeEvent && (
        <div className="event-modal" onClick={() => setActiveEvent(null)}>
          <div
            className="event-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="event-close" onClick={() => setActiveEvent(null)}>
              ✕
            </button>

            <h3>{activeEvent.title}</h3>

            <div className="event-gallery">
              {activeEvent.images.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt="event"
                  onClick={() => setActiveImage(img)}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Image Popup */}
      {activeImage && (
        <div className="image-modal" onClick={() => setActiveImage(null)}>
          <img src={activeImage} alt="popup" />
        </div>
      )}
    </section>
  );
};

export default Events;